













































































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import YouTubePlayer from '@/common/vue/youtube-player/YouTubePlayer.vue';
import ResponsiveImage from '@/common/vue/ResponsiveImage.vue';
import IntersectionDirective from '@/common/vue/intersection-directive';
import PlayOnYoutubeButton from '@/common/vue/play-on-youtube-button/PlayOnYoutubeButton.vue';
import ResizeUpdateMixin from '@/common/ts/resizing/ResizeUpdateMixin';
import TrackingPushService from '@/common/ts/tracking/TrackingPushService';

const Co2Labeling = () => import('@/webcomponents/co2-labeling/Co2Labeling.vue');
const Headline = () => import('@/webcomponents/headline/Headline.vue');
const ExpandMedia = () => import('@/webcomponents/expand-media/ExpandMedia.vue');
const RelaunchButton = () => import('@/common/vue/RelaunchButton.vue');

export const VIDEO_PLAYBACK_ENDED_EVENT = 'video-playback-ended';

const FullwidthMediaProps = Vue.extend({
  props: {
    editMode: Boolean,
    headlineText: String,
    headlineTag: {
      type: String,
      default: 'h1',
    },
    text: String,
    pictureJson: String,
    imageWidth: Number,
    imageHeight: Number,
    tabletImageWidth: Number,
    tabletImageHeight: Number,
    mobileImageWidth: Number,
    mobileImageHeight: Number,
    labelingJson: String,
    linkText: String,
    linkUrl: String,
    linkTarget: String,
    youtubeId: String,
    videoLength: String,
    textBelow: Boolean,
    textColor: {
      type: String,
      default: 'brand-primary',
    },
    buttonColor: {
      type: String,
      default: 'btn-dark',
    },
  },
});

@Component({
  directives: {
    intersect: IntersectionDirective,
  },
  components: {
    Headline,
    Co2Labeling,
    RelaunchButton,
    ResponsiveImage,
    ExpandMedia,
    YouTubePlayer,
    PlayOnYoutubeButton,
  },
})
export default class FullwidthMedia extends mixins(FullwidthMediaProps, ResizeUpdateMixin) {
  $refs!: {
    image: Vue;
  }

  rememberIntersecting = false;
  showImage = true;
  showMedia = false;

  get rootClasses () {
    return {
      'brandhub-fullwidth-media--text-on-image': !this.textBelow,
      'brandhub-fullwidth-media--text-primary': this.textColor === 'brand-primary' || this.isMobile,
      'brandhub-fullwidth-media--text-inverted': this.textColor === 'brand-primary-inverted' && !this.isMobile,
      'brandhub-fullwidth-media--labeling-black': this.isMobile || this.isTabletPortrait || this.textBelow,
      'brandhub-fullwidth-media--labeling-white': !this.isMobile && !this.isTabletPortrait && !this.textBelow,
      'brandhub-fullwidth-media--has-labeling': this.labelingJson,
      'brandhub-fullwidth-media--edit-mode': this.editMode,
    };
  }

  get headlineColor (): string {
    let color = '';
    if (this.textColor === 'brand-primary' || this.isMobile || this.isTabletPortrait) {
      color = 'black';
    } else if (this.textColor === 'brand-primary-inverted') {
      color = 'white';
    }
    return color;
  }

  get aspectRatio (): string {
    let aspectRatio = '';
    if (this.showMedia) {
      if (this.youtubeId) {
        aspectRatio = '16 / 9';
      }
    } else if (this.isMobile || this.isTabletPortrait) {
      aspectRatio = ''; // dynamic height for the overlay
    } else if (this.isTablet) {
      aspectRatio = `${this.tabletImageWidth} / ${this.tabletImageHeight}`;
    } else {
      aspectRatio = `${this.imageWidth} / ${this.imageHeight}`;
    }
    return aspectRatio;
  }

  get mediaStyles (): any {
    if (this.aspectRatio) {
      return {
        'aspect-ratio': this.aspectRatio,
      };
    }
    return null;
  }

  onButtonClick () {
    if (this.linkText) {
      TrackingPushService.getInstance().pushTrackingAttributes('link', 'Fullwidth Media', this.linkText, this.linkUrl);
    }
  }

  onButtonClose () {
    this.showMedia = false;
  }

  afterOverlayHidden () {
    this.showMedia = true;
  }

  afterMediaHidden () {
    this.showImage = true;
  }

  playVideo () {
    this.showImage = false;
  }
}
